export default "__VITE_ASSET__CfGCdpOu__"